// Colapsa cualquier cantidad de repeticiones consecutivas del `basename` al
// principio de un pathname a una sola — usado por `main.tsx` (arranque de la
// app y salvaguarda contra el path duplicado `/hce/paciente/hce/paciente/...`,
// bug real de producción 2026-09-02/03: `onUnauthenticated` guardaba
// `window.location.pathname` CON el prefijo en `next=`, pero
// `LandingAcceso.tsx` lo pasaba tal cual a `navigate()` de React Router, que
// bajo `basename` espera un path YA SIN el prefijo y lo volvía a anteponer).
// Función pura, separada de main.tsx (que corre código a nivel de módulo al
// importarse — no es testeable directo) para poder probarla con casos reales.
export function normalizarPathnameBasename(pathname: string, basename: string): string {
  let p = pathname;
  while (p.startsWith(basename) && p.slice(basename.length).startsWith(basename)) {
    p = p.slice(basename.length);
  }
  return p;
}
